import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, ListSubheader, MenuItem, TextField, Typography, useTheme } from '@mui/material';

interface StaticSelectProps {
    placeholder: string;
    onChange?: (e: any, v: any) => void;
    options: any[];
    value?: string;
    name: string | undefined;
    setFieldValue?: any;
    onBlur: any;
    isObject?: boolean;
    unit?: string;
    clearable?: boolean;
    selectStyle?: any;
    disabled?: boolean;
}

export const StaticSelect = ({
    options,
    onChange,
    onBlur,
    placeholder,
    value,
    name,
    unit,
    setFieldValue,
    isObject,
    clearable = false,
    disabled = false
}: StaticSelectProps) => {
    const theme = useTheme();
    return (
        <TextField
            sx={{
                '.MuiSelect-select': {
                    py: '10px'
                }
            }}
            fullWidth
            name={name}
            onBlur={onBlur}
            select
            value={value}
            disabled={disabled}
            SelectProps={{
                IconComponent: ExpandMoreIcon,
                onChange: onChange,
                displayEmpty: true,
                renderValue:
                    value !== ''
                        ? undefined
                        : () => (
                              <Typography color={theme.palette.grey[500]} fontWeight={400} fontFamily={'Nunito, sans-serif'}>
                                  {placeholder}
                              </Typography>
                          )
            }}
            InputProps={{
                endAdornment:
                    clearable && value !== '' ? (
                        <IconButton
                            size="small"
                            aria-label="clear"
                            sx={{ position: 'absolute', right: 30 }}
                            onClick={() => onChange?.({ target: { value: '' } }, '')}
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    ) : isObject ? (
                        <Typography
                            color="primary.main"
                            fontWeight={'normal'}
                            sx={{ position: 'absolute', right: 30, textTransform: 'capitalize' }}
                        >
                            {`${unit}`}
                        </Typography>
                    ) : null
            }}
        >
            {options.flatMap((item, index) => [
                ...(item.group && item.group !== options[index - 1]?.group
                    ? [<ListSubheader key={`group-${item.group}-${index}`}>{item.group}</ListSubheader>]
                    : []),
                <MenuItem key={`option-${item.value}`} value={isObject ? item : item.value}>
                    {item.label}
                </MenuItem>
            ])}
        </TextField>
    );
};
